import React from "react";

const SentenceUsage = () => {
    return <div>Sentence Usage</div>;
};

export default SentenceUsage;